import { Button } from "@snpjs/core";

import { Routes } from "../../routes/Routes";
import { openLinkInTab } from "../../utils/openLinkInTab";
import { texts } from "../../i18n/texts";
import useTranslation from "../../hooks/useTranslation";

/**
 * Admin View Button.
 */
export const AdminViewButton: React.FC = () => {
  const { t } = useTranslation();

  const onOpenAdminView = () => {
    openLinkInTab(`${window.location.origin}${Routes.adminView.toPath()}`);
  };

  return (
    <>
      <Button
        text={t(texts.adminView.adminView)}
        icon="user-circle-gear"
        minimal={true}
        onClick={onOpenAdminView}
      />
    </>
  );
};
